import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navLinks = [
    { name: 'How It Works', id: 'how-it-works' },
    { name: 'Features', id: 'features' },
    { name: 'Hospitals', id: 'hospitals' },
    { name: 'Pregnancy Guide', id: 'pregnancy-tracker' },
    { name: 'Baby Care', id: 'baby-care' },
    { name: 'Contact', id: 'contact' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white border-b border-gray-100' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className="flex items-center gap-3 cursor-pointer"
          >
            <div className="w-9 h-9 bg-gradient-to-br from-teal-500 to-sky-500 rounded-xl flex items-center justify-center shrink-0">
              <i className="ri-heart-pulse-line text-xl text-white"></i>
            </div>
            <span
              className={`text-2xl font-bold transition-colors ${
                isScrolled ? 'text-teal-700' : 'text-gray-900'
              }`}
              style={{ fontFamily: 'Dancing Script, cursive' }}
            >
              MomsFirstCare
            </span>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className={`font-medium text-sm transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled
                    ? 'text-gray-600 hover:text-teal-600'
                    : 'text-gray-700 hover:text-teal-600'
                }`}
              >
                {link.name}
              </button>
            ))}
          </div>

          {/* CTA button + mobile menu */}
          <div className="flex items-center gap-3">
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="hidden sm:flex px-5 py-2.5 bg-gradient-to-r from-teal-600 to-sky-500 text-white rounded-xl font-semibold text-sm hover:from-teal-700 hover:to-sky-600 transition-all whitespace-nowrap"
            >
              Get Started Free
            </button>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-xl transition-colors ${
                isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-gray-900 hover:bg-white/10'
              }`}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border border-gray-100 rounded-2xl mb-4 overflow-hidden">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="flex items-center w-full px-5 py-3.5 text-gray-700 hover:bg-teal-50 hover:text-teal-600 font-medium text-sm transition-colors whitespace-nowrap border-b border-gray-50 last:border-0"
              >
                {link.name}
              </button>
            ))}
            <div className="p-4">
              <button
                onClick={() => scrollToSection('how-it-works')}
                className="w-full px-6 py-3 bg-gradient-to-r from-teal-600 to-sky-500 text-white rounded-xl font-bold text-sm whitespace-nowrap"
              >
                Get Started Free
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
